import superagent from 'superagent'
import noCache from 'superagent-no-cache'

function requester(request) {
    request.url = (window.environmentConfig && window.environmentConfig.apiBaseUri) ? window.environmentConfig.apiBaseUri + request.url : request.url;
    // const r = request.accept('json')
    request.header = {"Cookies": document.cookie}
    return request
}

export default superagent
    .agent()
    .use(requester)
    .use(noCache)
